<!-- Header da Pagina -->
<div class="page-header">
  <div class="header-icon">
    <i class="pi pi-bookmark"></i>
  </div>
  <div class="header-content">
    <h1 class="header-title">{{ 'marca-edit.texts.edit_nova_marca' | translate }}</h1>
    <p class="header-subtitle">{{ 'marca-edit.texts.subtitulo' | translate }}</p>
  </div>
</div>

<!-- Grid de Cards -->
<div class="cards-container">
  <!-- Coluna Esquerda - Dados da Marca -->
  <div class="column-left">
    <div class="form-card">
      <div class="card-header">
        <div class="card-header-icon">
          <i class="pi pi-pencil"></i>
        </div>
        <span class="card-header-title">{{ 'marca-edit.texts.dados_marca' | translate }}</span>
      </div>
      <div class="card-content">
        <div class="form-grid">
          <div class="form-field full">
            <label class="form-label">{{ 'marca-edit.labels.nome' | translate }} <span class="required">*</span></label>
            <input type="text" pInputText [(ngModel)]="form.nome"
              [placeholder]="'marca-edit.placeholders.nome_do_marca' | translate" class="w-full" />
          </div>

          <div class="form-field full">
            <label class="form-label">{{ 'marca-edit.labels.codigo' | translate }}</label>
            <input type="text" pInputText [disabled]="true" [(ngModel)]="form.codigoMarca"
              [placeholder]="'marca-edit.placeholders.codigo_marca' | translate"
              class="w-full input-field-disabled" />
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Coluna Direita - Imagem -->
  <div class="column-right">
    <div class="form-card">
      <div class="card-header">
        <div class="card-header-icon image-icon">
          <i class="pi pi-image"></i>
        </div>
        <span class="card-header-title">{{ 'marca-edit.labels.imagem' | translate }}</span>
      </div>
      <div class="card-content">
        <p-fileUpload name="imagem" [customUpload]="true" [showUploadButton]="false" [showCancelButton]="true"
          [chooseLabel]="'marca-edit.botoes.selecionar_imagem' | translate"
          [cancelLabel]="'marca-edit.botoes.remover' | translate" [maxFileSize]="1000000"
          accept="image/png,image/jpeg,image/webp" (onSelect)="onSelectImage($event)" (onClear)="onClearImage()">
        </p-fileUpload>

        <!-- Preview: usa base64 selecionado OU a imagem atual do back -->
        <div class="image-preview" *ngIf="imagePreviewUrl || form.imagem">
          <img [src]="imagePreviewUrl || (env.imgHost + '/' + idEmpresa + '/marca/' + form.imagem)"
            [attr.alt]="'marca-edit.texts.imagem_da_marca' | translate" (error)="onImageError($event)" />
          <div class="filename">
            <small>{{ fileName || form.imagem }}</small>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Botoes de Acao -->
<div class="actions-container">
  <button pButton [label]="'marca-edit.botoes.voltar' | translate"
    (click)="navigateBack()" severity="secondary" icon="pi pi-arrow-left" class="btn-secondary"></button>
  <button pButton [label]="'marca-edit.botoes.salvar' | translate" icon="pi pi-check"
    (click)="submit()" class="btn-primary"></button>
</div>

<p-toast />
